import { Editor } from '../../editor/editor.model';
import { EditorRole } from '../../editor/editor.role.enum';
import { AuthModel } from './auth.model';

export interface AuthStateModel {
  isAuthenticated: boolean
  token: string | null
  editor: Editor | null // PL: would be nice to get the user in JsonApi Format for /login and /test, so we can use EditorJsonModel here
}

export class LoginAction {
  static readonly type = '[Auth] Login';

  constructor(public payload: AuthModel) {
  }
}

export class LogoutAction {
  static readonly type = '[Auth] Logout';
}

export class CheckTokenAction {
  static readonly type = '[Auth] Check Token';
}

export class SetUserAndAuthStatus {
  static readonly type = '[Auth] Set User and Auth Status';

  constructor(public payload: {
    isAuthenticated: boolean
    userRole: EditorRole | null
  }) {
  }
}
